var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper wrapper-full-page full-page"},[_c('router-view'),_c('footer-component',{attrs:{"mode":"light","absolute":"true"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }